import { Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { InsightsServiceApi } from '../insights.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UtilsService } from '../../../services/utils.service';
import { DownloadFileService } from '../../../services/downloadFile.service';
import * as PairingConst from 'src/app/pairing.constants';
import { Router } from '@angular/router';


@Component({
  selector: 'app-pricefx-loader',
  templateUrl: './pricefx-loader.component.html',
  styleUrls: ['./pricefx-loader.component.scss'],
  standalone: false
})
export class PricefxLoaderComponent implements OnInit {

  @ViewChild('powerBIContainer', { static: true }) powerBIContainer!: ElementRef;
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
  showBoolean: boolean;
  regions: any = [];
  productLines: any = [];
  requstList: any = [];
  message: boolean = false;
  priceFxForm: FormGroup;
  selectedRegion: any;
  selectedProductLine: string[] = [];
  selectedRequest1: any;
  selectedRequest2: any;
  embadedURL: any;
  embedToken: any;
  reportId: any;
  fileName1: any;
  request2Type: any;
  request1Type: any;
  uploadedFile2: any;
  uploadedFile1: any;
  isFileUploaded2: boolean = false;
  isFileUploaded1: boolean = false;
  isPLDisabled: boolean = true;
  isPR1Disabled: boolean = true;
  isPR2Disabled: boolean = true;
  isFileUploadDisabled: boolean = true;
  isFileUploadDisabled1: boolean = true;
  isSubmitDisabled: boolean = true;
  retryCount = 0;
  maxRetries = 10;
  getSharingErorr: any
  isShowErrorMessageWithToast: boolean;
  displayStyle: string;
  isSKUAllowed: boolean = false;
  isPriceFXLoaderAllowed: boolean = false;
  isCoverageReportAllowed: boolean = false;
  valid_from_date: string = null;
  validFromDate: string = null;
  validStartDate: string = '';

  // Tab management
  activeTab: string = 'insights';

  isConfirmationPopupVisibale: boolean;
  popupMessage: any;
  isSuccessToast: boolean = true;
  errorFlag: boolean = false;
  fileError: any;
  fileError1: any;
  getFileSize: any;
  uploadProgress = 0;
  uploadInProgress = false;
  getSharingError: any;
  validFromDateFlag: boolean;
  priceDateFlag: boolean;
  isValidFromDateValidation: boolean;
  isValidFromDateVisible: boolean;
  getFileSize1: number;
  getFileSize2: number;
  errorFlag1: boolean;
  errorFlag2: boolean;
  fileError2: string;
  fileName2: any;


  constructor(private readonly insightsServiceApi: InsightsServiceApi,
    private readonly spinnerService: NgxSpinnerService,
    private fb: FormBuilder,
    private readonly utilService: UtilsService,
    private readonly downloadFileService: DownloadFileService,
    private router: Router) { }


  ngOnInit() {

    this.utilService.SharingData.subscribe((res: any) => {
      this.getSharingErorr = res;
    });
    this.getRegionDetails();
    this.requestSubmitted = false;
    this.buildForm();

    this.utilService.SharingData.subscribe((res: any) => {
      this.getSharingError = res;
    });
    const insightSubModuleArray = JSON.parse(sessionStorage.getItem('insightSubModule') || '[]');

    if (insightSubModuleArray.includes('PriceFx Loader')) {
      this.isPriceFXLoaderAllowed = true;
    }

    if (insightSubModuleArray.includes('SKU Generator')) {
      this.isSKUAllowed = true;
    }

    if (insightSubModuleArray.includes('Coverage Report')) {
      this.isCoverageReportAllowed = true;
    }
  }

  isPLOpen = false
  isRegionOpen = false
  isPR1Open = false
  isPR2Open = false

  requestSubmitted = false

  openPL() {
    this.isPLOpen = !this.isPLOpen
    this.isRegionOpen = false
    this.isPR1Open = false
    this.isPR2Open = false
  }

  openReg() {
    this.isPLOpen = false
    this.isRegionOpen = !this.isRegionOpen
    this.isPR1Open = false
    this.isPR2Open = false
  }

  openPR1() {
    this.isPLOpen = false
    this.isRegionOpen = false
    this.isPR1Open = !this.isPR1Open
    this.isPR2Open = false
  }

  openPR2() {
    this.isPLOpen = false
    this.isRegionOpen = false
    this.isPR1Open = false
    this.isPR2Open = !this.isPR2Open
  }

  // Tab management methods
  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  buildForm() {
    this.priceFxForm = this.fb.group({
      userId: [''],
      productLine: [[]],
      region: [[]],
      baseFileFromRequestId: [''],
      baseFileFromFileName: [''],
      currentFileFromFileName: [''],
      currentFileFromRequestId: [''],
      valid_from_date: [''],
      validFromDate: ['']
    });
  }

  onFileSelected(event: Event, fileNumber: number): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      if (fileNumber === 1) {
        this.uploadedFile1 = input.files[0];
        this.getFileSize1 = input.files[0].size;
      } else if (fileNumber === 2) {
        this.uploadedFile2 = input.files[0];
        this.getFileSize2 = input.files[0].size;
      }
      this.uploadReport(fileNumber);
    }
  }

  private handlePopupMessage(isShowPopupMessage: boolean, message: string, isSuccess: boolean) {
    if (isShowPopupMessage) {
      this.popupMessage = message
      this.isSuccessToast = isSuccess;
      this.displayStyle = 'none';
      this.isConfirmationPopupVisibale = true;
      this.isShowErrorMessageWithToast = true;
      this.utilService.isTosterVisible(true, message);
      setTimeout(() => {
        this.isShowErrorMessageWithToast = false;
        this.utilService.isTosterVisible(false, '');
      }, 5000);

    } else {
      this.isShowErrorMessageWithToast = false;
    }
  }
  actionOnConfirmation() {

    this.selectedProductLineIds.set([]);
    this.selectedRegions.set([]);
    this.selectedPR1.set({ requestId: '', label: '' });
    this.selectedPR2.set({ requestId: '', label: '' });
    this.fileInputRef.nativeElement.value = '';
    this.selectedRegion = '';
    this.selectedProductLine = [];
    this.selectedRequest1 = '';
    this.selectedRequest2 = '';
    this.request2Type = '';
    this.request1Type = '';
    this.isFileUploaded2 = false;
    this.isFileUploaded1 = false;
    this.displayStyle = 'none';

  }

  // regions call
  getRegionDetails() {
    this.insightsServiceApi
      .getRegions()
      .subscribe(
        (res) => {
          const regionLsts = res;
          this.regions = regionLsts.result;
          this.regions = this.regions.filter(function (el: any) {
            return el !== 'NULL';
          });
          this.showBoolean = false;
        },
        (err) => {
          this.spinnerService.hide();
          this.showBoolean = true;
        }
      );
  }

  getProductLineDetails(regionCodeOnEdit: any) {
    this.insightsServiceApi
      .getProductLines(
        regionCodeOnEdit
      )
      .subscribe(
        (res) => {
          const productLineLists = res;
          this.productLines = productLineLists.result;
          this.productLines = this.productLines.filter(function (el: any) {
            return el !== 'NULL';
          });

          //this.isProductLineDisabledOnRegion = true;
          return this.productLines;
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  getPairingRquest() {
    const productLineCodes = this.selectedProductLineIds()
      .map(desc => this.getPLCodeByDescription(desc))
      .filter((c): c is string => !!c);
    this.selectedProductLine = productLineCodes;
    this.insightsServiceApi
      .getPairingRequest(this.selectedRegion, productLineCodes)
      .subscribe(
        (res) => {
          console.log(res);
          const requestLists = res;
          this.requstList = requestLists.result;
          this.requstList = this.requstList.filter(function (el: any) {
            return el !== 'NULL';
          });
          return this.requstList;
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }


  uploadReport(fileNumber: number) {
    let formData = new FormData();
    formData.append('userId', sessionStorage.getItem('userId'));
    formData.append('productLineCode', 'PCLT');
    formData.append('regionCode', this.selectedRegion);
    formData.append('module', 'PriceFx Loader');
    if (fileNumber === 1) {
      formData.append('file', this.uploadedFile1);
    } else if (fileNumber === 2) {
      formData.append('file', this.uploadedFile2);
    }
    this.spinnerService.show();
    this.insightsServiceApi.uploadReport(formData).subscribe(
      (response: any) => {

        const getFileResponse: any = response;
        if (getFileResponse.body.message === 'OK') {
          if (fileNumber === 1) {
            this.isFileUploaded1 = true;
            this.errorFlag1 = false;
            this.fileError1 = '';
            this.fileName1 = getFileResponse.body.result;
          } else if (fileNumber === 2) {
            this.isFileUploaded2 = true;
            this.errorFlag2 = false;
            this.fileError2 = '';
            this.fileName2 = getFileResponse.body.result;
          }
          this.isSubmitDisabled = false;
          this.isPR2Disabled = false;
        } else {
          if (fileNumber === 1) {
            this.errorFlag1 = true;
            this.fileError1 = getFileResponse.body.message;
          } else if (fileNumber === 2) {
            this.errorFlag2 = true;
            this.fileError2 = getFileResponse.body.message;
          }
        }
        setTimeout(() => {
          this.spinnerService.hide();
        }, 1000);
      },
      (error: any) => {
        if (fileNumber === 1) {
          this.errorFlag1 = true;
          this.fileError1 = this.getSharingError;
        } else if (fileNumber === 2) {
          this.errorFlag2 = true;
          this.fileError2 = this.getSharingError;
        }
        setTimeout(() => {
          this.spinnerService.hide();
        }, 1000);
      }
    );
  }


  reqSubmit() {
    this.requestSubmitted = true;
    let request2: any;
    let request1: any;
    if (this.fileName1 === undefined) {
      this.fileName1 = '';
    }
    if (this.fileName1 && this.fileName1 !== '') {
      this.request1Type = 'UPLOAD';
      request1 = this.fileName1;
    } else {
      this.request1Type = 'Pairing Request';
      request1 = 'PAIR-' + this.selectedRequest1;
    }

    if (this.fileName2 && this.fileName2 !== '') {
      this.request2Type = 'UPLOAD';
      request2 = this.fileName2;
    } else {
      this.request2Type = 'Pairing Request';
      request2 = 'PAIR-' + this.selectedRequest2;
    }



    this.selectedProductLine = this.selectedProductLine.map(code => code === 'TC' ? 'PCLT' : code);
    this.priceFxForm.patchValue({
      userId: sessionStorage.getItem('userId'),
      productLine: this.selectedProductLine,
      region: this.selectedRegion,
      baseFileFromRequestId: this.selectedRequest1,
      currentFileFromRequestId: this.selectedRequest2,
      baseFileFromFileName: this.fileName1,
      currentFileFromFileName: this.fileName2,
    });

    if ('PAIR-' + this.selectedRequest1 === request2) {
      this.handlePopupMessage(true, 'Both requests must not be same.', false);
    } else {
      this.isSubmitDisabled = true;
      this.insightsServiceApi
        .onsubmitPriceFxLoader(this.priceFxForm.value)
        .subscribe(
          (res: any) => {
            if (res.result.requestId) {
              this.handlePopupMessage(true, `Request ID ${res.result.requestId} has been updated successfully.`, true);
              this.utilService.goToTop();

            } else {
              this.handlePopupMessage(true, 'No Records Found', false);
            }

            setTimeout(() => {
              this.isSubmitDisabled = false;
              this.clearData('region');
              this.selectedRegion = '';
              this.selectedRegions.set([]);
            }, 5000);
          },
          (err: any) => {
            setTimeout(() => {
              this.isSubmitDisabled = false;
            }, 5000);
          }
        );
    }

  }


  selectedProductLineIds = signal<string[]>([]);
  selectedRegions = signal<string[]>([]);
  selectedPR1 = signal<{ requestId: string; label: string } | null>(null);
  selectedPR2 = signal<{ requestId: string; label: string } | null>(null);

  togglePLSelection(name: string) {
    const MULTI_SELECT_CODES = ['CT', 'MIN'];
    const code = this.getPLCodeByDescription(name);

    if (code && MULTI_SELECT_CODES.includes(code)) {
      // Multi-select: toggle within CT/MIN selections, clear any non-CT/MIN previously selected
      const current = this.selectedProductLineIds().filter(desc => {
        const c = this.getPLCodeByDescription(desc);
        return c && MULTI_SELECT_CODES.includes(c);
      });
      if (current.includes(name)) {
        const updated = current.filter(d => d !== name);
        this.selectedProductLineIds.set(updated);
        if (updated.length === 0) {
          this.selectedProductLine = [];
          this.isPR1Disabled = true;
          this.isPR2Disabled = true;
          this.isFileUploadDisabled = true;
          this.isSubmitDisabled = true;
          return;
        }
      } else {
        this.selectedProductLineIds.set([...current, name]);
      }
      // Keep dropdown open for multi-select
    } else {
      this.clearData('productLine');
      this.selectedProductLineIds.set([name]);
      this.isPLOpen = false;
      this.selectedProductLine = [this.getPLCodeByDescription(name)].filter((c): c is string => !!c);
    }

    this.getPairingRquest();
    this.isPR1Disabled = false;
    this.isPR2Disabled = true;
    this.isFileUploadDisabled = true;
    this.isSubmitDisabled = true;
  }

  toggleRegionSelection(name: string) {
    this.clearData('region');
    this.selectedRegions.set([name]);
    this.isRegionOpen = false;
    this.selectedRegion = this.selectedRegions()[0];
    this.selectedRegion = this.getRegionCodeByName(this.selectedRegion);
    this.getProductLineDetails(this.selectedRegion);
    this.isPLDisabled = false;
    this.isPR1Disabled = true;
    this.isPR2Disabled = true;
    this.isFileUploadDisabled = true;
    this.isSubmitDisabled = true;
  }


  togglePR1Selection(requestId: string) {
    const selected = this.requstList.find((req: { requestId: string; label: string }) => req.requestId === requestId) || null;
    this.selectedPR1.set(selected);
    this.isPR1Open = false;
    this.selectedRequest1 = requestId;
    this.isPR2Disabled = false;
    this.isFileUploadDisabled = false;
    this.isSubmitDisabled = true;
  }

  togglePR2Selection(requestId: string) {
    const selected = this.requstList.find((req: { requestId: string; label: string }) => req.requestId === requestId) || null;
    this.selectedPR2.set(selected);
    this.isPR2Open = false;
    this.selectedRequest2 = requestId;
    this.isSubmitDisabled = false;
  }

  getRegionCodeByName(name: string): string | undefined {
    const region = this.regions.find((r: { regionName: string; }) => r.regionName === name);
    return region?.regionCode;
  }

  getPLCodeByDescription(name: string): string | undefined {
    const pl = this.productLines.find((r: { description: string; }) => r.description === name);
    return pl?.code;
  }

  simulateUpload(): void {
    this.uploadInProgress = true;
    this.uploadProgress = 0;

    const interval = setInterval(() => {
      this.uploadProgress += 10;

      if (this.uploadProgress >= 100) {
        clearInterval(interval);
        setTimeout(() => {
          this.uploadInProgress = false;
        }, 500);
      }
    }, 300);
  }

  goToHome() {
    this.router.navigate(['/home']);
  }


  clearData(type: string) {
    if (type === 'region') {
      this.selectedProductLineIds.set([]);
      this.selectedProductLine = [];
    }
    this.requstList = [];
    this.isFileUploaded2 = false;
    this.isFileUploaded1 = false;
    this.errorFlag1 = false;
    this.fileError1 = '';
    this.errorFlag2 = false;
    this.fileError2 = '';
    this.getFileSize1 = null;
    this.getFileSize2 = null;
    this.fileName1 = '';
    this.fileName2 = '';
    this.selectedPR1.set(null);
    this.selectedPR2.set(null);
    if (this.fileInputRef?.nativeElement) {
      this.fileInputRef.nativeElement.value = '';
    }
    this.selectedRequest1 = '';
    this.selectedRequest2 = '';
    this.validFromDate = null;
    this.valid_from_date = null;
    this.validStartDate = '';
    this.request2Type = '';
    this.request1Type = '';
    this.displayStyle = 'none';
  }

  downloadPriceFXFile() {
    this.downloadFileService.downloadPriceFXFile();
  }

  public fileOver(event: any) {
    console.log(event);
  }

  public fileLeave(event: any) {
    console.log(event);
  }

  onMonthPickerOpen() {
    this.validFromDateFlag = true;
    this.priceDateFlag = false;
    this.isValidFromDateValidation = true;
    this.isValidFromDateVisible = !this.isValidFromDateVisible;
    this.utilService.isCalendarPopUpOpen.subscribe(
      (res) => {
        const checkResValue = res;
        if (checkResValue) {
          this.isValidFromDateVisible = true;
        } else {
          this.isValidFromDateVisible = false;
        }
      },
      (err: any) => {
        this.spinnerService.hide();
        console.log(err);
      }
    );

  }

  logRange2(event: any) {

    const getString = event.split(':')[1].replace('to', '-');

    const Month = PairingConst.Month;
    const indexMonth = PairingConst.IndexMonth;
    const monthNumber3 = indexMonth[
      Month.indexOf(
        event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1]
      )
    ];
    const monthNumber1 =
      indexMonth[
      Month.indexOf(
        event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1]
      )
      ];

    const month1 = new Date();
    month1.setDate(1);
    month1.setMonth(monthNumber1 - 1);

    let m1;
    m1 = getString.replace(
      event.split(':')[1].replace('to', '-').split('-')[0].split(' ')[1],
      month1.toLocaleString('en-US', { month: 'long' })
    );

    this.valid_from_date = m1.trimStart();
    this.validFromDate = this.valid_from_date;

    const m3 = month1.toLocaleString('en-US', { month: '2-digit' });
    const year1 = this.valid_from_date.split(' ')[1];
    this.validStartDate = year1 + '-' + m3;
    this.priceFxForm.patchValue({
      valid_from_date: this.validStartDate,
      validFromDate: this.validFromDate,
    });
  }


}
